var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{ref:"refUserListTable",staticClass:"position-relative rounded",attrs:{"sticky-header":"","items":_vm.dataList,"responsive":"","fields":_vm.tableColumns,"show-empty":"","empty-text":"No matching records found"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }